export default __webpack_public_path__ + "static/media/11.917a21fb.jpg";